<template>
  <div class="okanGraph"
  v-bind:class="{
    ['okanGraph'] : true,
    ['disabled'] : okanMap.colorBlueprintMode == true && okanMap.showColorPicker == true
  }">
    <div id="graphHeader">
      <h3>Hotels : circle radius</h3>
    </div>
    <canvas class="graphCanvas" v-bind:id="canvasId" width='2000' height='2000' style='border: none; '></canvas>
    <div id="graphMenu">
      <div id="graphMenuButtons">
        <button
        v-on:click="startGraph" title="Live editing" class="livebutton">
          <div class="graphLive" v-if="liveEditing"></div>
          Live editing
        </button>
        <button
        v-on:click="cancel()" title="Cancel" class="graphMenuButton">Cancel</button>
        <button
        v-on:click="saveGraph()" title="Save" class="graphMenuButton">Save</button>
      </div>
      


      <input type="text" id="graphResultTest" v-model="result" />
    </div>

    
  </div>
</template>

<script>
import Vue from 'vue'

LiteGraph.registered_node_types = {};

LiteGraph.NODE_SLOT_HEIGHT = 16;
LiteGraph.NODE_TITLE_HEIGHT = 40;
LiteGraph.NODE_TITLE_COLOR = '#e5e5e5';
LiteGraph.NODE_COLLAPSED_WIDTH = 200;
LiteGraph.NODE_WIDTH = 200;
LiteGraph.NODE_MIN_WIDTH = 200;
LiteGraph.NODE_COLLAPSED_RADIUS = 100;

LiteGraph.VALID_SHAPES = ["default","box","round","card", "circle"];

let all_fields = [];

let nameFinalNode = '';

let okanMap = null;

export default {
  name: 'okanGraph',
  props: {
    okanMap : Object
  },
	data: function() {
		return {

      canvasId : 'lg_' + this.randomString(10),
      graph : new LGraph(),
      canvas : null,
      result : '',
      liveEditing : false,
      intervalApply: null,
      applyWorking: false,
      originalExpression : null,


		}
  },
  mounted() {
    okanMap = this.okanMap;
    all_fields = this.okanMap.graph_getFields;
    nameFinalNode = this.okanMap.graph_finalNodeName;

    this.canvas = new LGraphCanvas("#"+this.canvasId, this.graph);

    
    this.registerNodes();
    
    this.init();

    
		
	},
	created() {

	},
	destroyed() {

	},
	methods : {

    init() {
      this.result = this.originalExpression;

      //console.log('graph init');
      //console.log(this.graph);

      all_fields = this.okanMap.graph_getFields;
      nameFinalNode = this.okanMap.graph_finalNodeName;


      this.reset();
      setTimeout(() =>{ 
        this.load();
      }, 300);
      


    },

    reset(){
      this.graph.clear();
    },

    load() {
      all_fields = this.okanMap.graph_getFields;

      if(this.okanMap.graphSave != null) {
        console.log('loading graph save', this.okanMap.graphSave)

        try {
          this.graph.configure(this.okanMap.graphSave);
        }
        catch(e) {
          console.log(e)
        }
        
      }
      else{
        console.log('Creating final node for first graph...')
        var radiusnode = LiteGraph.createNode("FINAL/FINAL");
        radiusnode.pos = [500,500];
        this.graph.add(radiusnode);
      }
      

    },

    close() {

    },

    cancel() {

      this.applyExpression();
      
      
      this.graph.start();

      setTimeout(() =>{ 
        this.graph.stop();
        if(this.liveEditing) {
          clearInterval(this.intervalApply);
          this.liveEditing = false;
        }
        console.log('cancel expression, reverting to old: ', this.originalExpression);
        this.$emit('cancel', this.originalExpression )
      }, 100);

      this.okanMap.graphOpen = false;


    },

    startGraph() {

      if(this.liveEditing) {
        this.graph.stop();
        clearInterval(this.intervalApply);
      }
      else {
        this.graph.start();

        this.intervalApply = setInterval(this.applyExpression, 10);

      }
      this.liveEditing = !this.liveEditing;
      

      //console.log(this.graph);
      
    },

    applyExpression(original = false){

      if(!this.applyWorking) {
        this.applyWorking = true;
        this.graph.start();

        setTimeout(() =>{ 
          this.graph.stop();
          //console.log('applying expression', this.result);
          if(!original)
            this.$emit('apply', this.result)
          else
            this.$emit('apply', this.originalExpression)
          this.applyWorking = false;
        }, 10);

      }

      

    },

    saveExpression(){

      this.graph.start();

      setTimeout(() =>{ 
        this.graph.stop();
        if(this.liveEditing) {
          clearInterval(this.intervalApply);
          this.liveEditing = false;
        }
        console.log('saving expression', this.result);
        this.$emit('save', this.result, JSON.stringify( this.graph.serialize() )  )
      }, 100);
      
    },

    saveGraph(){
      this.applyExpression();
      this.saveExpression();

      this.okanMap.graphOpen = false;

    },

    registerNodes() {
      

      this.register_final();

      this.register_get();
      this.register_interpolate();
      this.register_zoom();
      this.register_constant();
      this.register_math();
      this.register_otherData();
      this.register_conditional();
      this.register_conversions();
      this.register_color();



      console.log('LiteGraph', LiteGraph)

      console.log('this.graph', this.graph);

    },

    register_final(){
      n_FINALOUTPUT.title = 'FINAL';
      var context = this;
      n_FINALOUTPUT.prototype.onExecute = function()
      {
        var A = this.getInputData(0);

        //console.log(A);
        context.result = A;
        
        this.setOutputData( 0, A );
      }

      LiteGraph.registerNodeType("FINAL/FINAL", n_FINALOUTPUT );

    },

    register_get(){
      n_GET.title = "GET";
      n_GET.prototype.onExecute = function()
      {
        var value = this.combo.value;
        this.setOutputData( 0, "['get', '"+this.properties["value"] +"']" );
      }

      n_GET.prototype.setValue = function(v)
      {
        this.properties["value"] = v;
        this.setDirtyCanvas(true);
      };

      n_GET.prototype.onDrawBackground = function(ctx)
      {
        //show the current value
        this.outputs[0].label = this.properties["value"];
      }
      n_GET.prototype.onPropertyChanged = function(ctx)
      {
        //show the current value
        this.combo.value = this.properties["value"];
        this.outputs[0].label =this.properties["value"];
      }

      LiteGraph.registerNodeType("Data/GET", n_GET );

    },

    register_interpolate(){
      n_INTERPOLATE.title = "Interpolate";
      n_INTERPOLATE.prototype.onExecute = function()
      {
        //var comboEasing = this.comboEasing.value;
        var comboEasing = 'linear';
        
        var stepPairs = this.properties['steppairs']; // [ input val, output val ]

        var stepOutputStr = '';

        stepPairs.forEach((step) => {
          stepOutputStr += this.getInputData(step[0]) + ' , ' + this.getInputData(step[1]) + ' , ';
        })

        

        stepOutputStr = stepOutputStr.substr(0,stepOutputStr.length - 2 );

        //var comboInput = this.comboXaxis.value;
        var input = this.getInputData(0);

        if(comboEasing == 'linear') {
          this.setOutputData( 0, "['interpolate', ['"+comboEasing+"'], "+input+", "+stepOutputStr+"]" );
        }
        else {
          this.setOutputData( 0, "['step', '"+input+"', "+stepOutputStr+"]" );
        }
        
      }

      LiteGraph.registerNodeType("Behaviour/Interpolate", n_INTERPOLATE );

    },

    register_zoom(){
      n_ZOOM.title = "ZOOM";
      n_ZOOM.prototype.onExecute = function()
      {
        //var value = this.combo.value;
        this.setOutputData( 0, "['zoom']" );
      }

      LiteGraph.registerNodeType("Data/ZOOM", n_ZOOM );

    },

    register_constant(){
      n_CONSTANT.title = "CONSTANT";
      n_CONSTANT.desc = "Constant value";
      n_CONSTANT.prototype.onExecute = function()
      {
        //var value = this.inputNumber.value;
        //this.setOutputData( 0, value );
        this.setOutputData(0, parseFloat( this.properties["value"] ) );
      }

      n_CONSTANT.prototype.setValue = function(v)
      {
        if( typeof(v) == "string") v = parseFloat(v);
        this.properties["value"] = v;
        this.setDirtyCanvas(true);
      };

      n_CONSTANT.prototype.onDrawBackground = function(ctx)
      {
        //show the current value
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
      }
      n_CONSTANT.prototype.onPropertyChanged = function(ctx)
      {
        //show the current value
        this.inputNumber.value = Number(this.properties["value"]).toFixed(3);
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
      }
      LiteGraph.registerNodeType("Data/CONSTANT", n_CONSTANT );

    },

    register_math() {

      
      n_SUM.title = "Sum";
      n_SUM.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['+', "+A+"]" );
      }

      n_ADD.title = "Add";
      n_ADD.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['+', "+A+", "+B+"]" );
      }

      n_SUB.title = "Sub";
      n_SUB.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['-', "+A+", "+B+"]" );
      }

      n_DIV.title = "Divide";
      n_DIV.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['/', "+A+", "+B+"]" );
      }

      n_MULT.title = "Multiply";
      n_MULT.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['*', "+A+", "+B+"]" );
      }

      n_POW.title = "Power";
      n_POW.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['^', "+A+", "+B+"]" );
      }

      n_MOD.title = "Modulo";
      n_MOD.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['%', "+A+", "+B+"]" );
      }

      n_COS.title = "Cosinus";
      n_COS.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['cos', "+A+"]" );
      }

      n_SIN.title = "Sinus";
      n_SIN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['sin', "+A+"]" );
      }

      n_TAN.title = "Tangent";
      n_TAN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['tan', "+A+"]" );
      }

      n_ACOS.title = "ArcCosinus";
      n_ACOS.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['acos', "+A+"]" );
      }

      n_ASIN.title = "ArcSinus";
      n_ASIN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['asin', "+A+"]" );
      }

      n_ATAN.title = "ArcTangent";
      n_ATAN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['atan', "+A+"]" );
      }

      n_CEIL.title = "Ceil";
      n_CEIL.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['ceil', "+A+"]" );
      }

      n_ROUND.title = "Round";
      n_ROUND.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['round', "+A+"]" );
      }

      n_FLOOR.title = "Floor";
      n_FLOOR.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['floor', "+A+"]" );
      }

      n_ABS.title = "Absolute";
      n_ABS.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['abs', "+A+"]" );
      }

      n_LN.title = "LN";
      n_LN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['ln', "+A+"]" );
      }

      n_LOG10.title = "Log10";
      n_LOG10.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['log10', "+A+"]" );
      }

      n_LOG2.title = "Log2";
      n_LOG2.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['log2', "+A+"]" );
      }

      n_MIN.title = "Min";
      n_MIN.prototype.onExecute = function()
      {
        var stepOutputStr = this.getInputData(0) + ',' + this.getInputData(1);
        this.inputsIndexes.forEach((step) => {
          stepOutputStr += ' , ' + this.getInputData(step);
        })
        this.setOutputData( 0, "['min', "+stepOutputStr+"]" );
      }

      n_MAX.title = "Max";
      n_MAX.prototype.onExecute = function()
      {
        var stepOutputStr = this.getInputData(0) + ',' + this.getInputData(1);
        this.inputsIndexes.forEach((step) => {
          stepOutputStr += ' , ' + this.getInputData(step);
        })
        this.setOutputData( 0, "['max', "+stepOutputStr+"]" );
      }

      n_PI.title = "PI";
      n_PI.prototype.onExecute = function()
      {
        this.setOutputData( 0, "['pi']" );
      }

      n_E.title = "e";
      n_E.prototype.onExecute = function()
      {
        this.setOutputData( 0, "['e']" );
      }

      n_LN2.title = "Ln2";
      n_LN2.prototype.onExecute = function()
      {
        this.setOutputData( 0, "['ln2']" );
      }


      
      LiteGraph.registerNodeType("Math/Sum", n_SUM );

      LiteGraph.registerNodeType("Math/Add", n_ADD );
      LiteGraph.registerNodeType("Math/Sub", n_SUB );
      LiteGraph.registerNodeType("Math/Divide", n_DIV );
      LiteGraph.registerNodeType("Math/Multiply", n_MULT );
      LiteGraph.registerNodeType("Math/Power", n_POW );

      LiteGraph.registerNodeType("Math/Modulo", n_MOD );

      LiteGraph.registerNodeType("Math/Cos", n_COS );
      LiteGraph.registerNodeType("Math/Sin", n_SIN );
      LiteGraph.registerNodeType("Math/Tan", n_TAN );
      LiteGraph.registerNodeType("Math/Acos", n_ACOS );
      LiteGraph.registerNodeType("Math/Asin", n_ASIN );
      LiteGraph.registerNodeType("Math/Atan", n_ATAN );

      LiteGraph.registerNodeType("Math/Ln", n_LN );
      LiteGraph.registerNodeType("Math/Log10", n_LOG10 );
      LiteGraph.registerNodeType("Math/Log2", n_LOG2 );
      

      LiteGraph.registerNodeType("Math/Ceil", n_CEIL );
      LiteGraph.registerNodeType("Math/Round", n_ROUND );
      LiteGraph.registerNodeType("Math/Floor", n_FLOOR );
      LiteGraph.registerNodeType("Math/Abs", n_ABS );

      LiteGraph.registerNodeType("Math/Min", n_MIN );
      LiteGraph.registerNodeType("Math/Max", n_MAX );

      LiteGraph.registerNodeType("Math/PI", n_PI );
      LiteGraph.registerNodeType("Math/e", n_E );
      LiteGraph.registerNodeType("Math/ln2", n_LN2 );

    },

    register_otherData(){
      
      n_HEATMAPDENSITY.title = "Heatmap density";
      n_HEATMAPDENSITY.prototype.onExecute = function()
      {
        this.setOutputData( 0, "['heatmap-density']" );
      }

      n_POINTCOUNT.title = "Point count";
      n_POINTCOUNT.prototype.onExecute = function()
      {
        this.setOutputData( 0, "['get', 'point_count']" );
      }

      //

      LiteGraph.registerNodeType("Heatmap/Heatmap density", n_HEATMAPDENSITY );
      LiteGraph.registerNodeType("Cluster/Point count", n_POINTCOUNT );
    },

    register_conditional() {

      n_CASE.title = "Case";
      n_CASE.prototype.onExecute = function()
      {
        var condition = this.getInputData(0);
        var val_true = this.getInputData(2);
        var val_false = this.getInputData(3);
        
        this.setOutputData( 0, "['case', "+condition+", "+val_true+", "+val_false+"]" );
      }

      n_INF.title = "<";
      n_INF.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['<', "+A+", "+B+"]" );
      }

      n_SUP.title = ">";
      n_SUP.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['>', "+A+", "+B+"]" );
      }

      n_INFequal.title = "<=";
      n_INFequal.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['<=', "+A+", "+B+"]" );
      }

      n_SUPequal.title = ">=";
      n_SUPequal.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['>=', "+A+", "+B+"]" );
      }

      n_EQUAL.title = "==";
      n_EQUAL.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['==', "+A+", "+B+"]" );
      }

      n_NOTEQUAL.title = "!=";
      n_NOTEQUAL.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['!=', "+A+", "+B+"]" );
      }

      n_NOT.title = "!NOT";
      n_NOT.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['!', "+A+"]" );
      }

      n_ALL.title = "ALL";
      n_ALL.prototype.onExecute = function()
      {
        var stepOutputStr = this.getInputData(0) + ',' + this.getInputData(1);
        this.inputsIndexes.forEach((step) => {
          stepOutputStr += ' , ' + this.getInputData(step);
        })
        this.setOutputData( 0, "['all', "+stepOutputStr+"]" );
      }

      n_ANY.title = "ANY";
      n_ANY.prototype.onExecute = function()
      {
        var stepOutputStr = this.getInputData(0) + ',' + this.getInputData(1);
        this.inputsIndexes.forEach((step) => {
          stepOutputStr += ' , ' + this.getInputData(step);
        })
        this.setOutputData( 0, "['any', "+stepOutputStr+"]" );
      }

      n_NONE.title = "NONE";
      n_NONE.prototype.onExecute = function()
      {
        var stepOutputStr = this.getInputData(0) + ',' + this.getInputData(1);
        this.inputsIndexes.forEach((step) => {
          stepOutputStr += ' , ' + this.getInputData(step);
        })
        this.setOutputData( 0, "['none', "+stepOutputStr+"]" );
      }


      LiteGraph.registerNodeType("Conditional/Case", n_CASE );

      LiteGraph.registerNodeType("Conditional/<", n_INF );
      LiteGraph.registerNodeType("Conditional/>", n_SUP );
      LiteGraph.registerNodeType("Conditional/<=", n_INFequal );
      LiteGraph.registerNodeType("Conditional/>=", n_SUPequal );
      LiteGraph.registerNodeType("Conditional/==", n_EQUAL );
      LiteGraph.registerNodeType("Conditional/==", n_NOTEQUAL );
      LiteGraph.registerNodeType("Conditional/NOT", n_NOT );
      LiteGraph.registerNodeType("Conditional/ALL", n_ALL );
      LiteGraph.registerNodeType("Conditional/ANY", n_ANY );
      LiteGraph.registerNodeType("Conditional/NONE", n_NONE );
    },

    register_conversions(){
      n_TO_NUMBER.title = "To Number";
      n_TO_NUMBER.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        var B = this.getInputData(1);
        this.setOutputData( 0, "['to-number', "+A+", "+B+"]" );
      }

      n_TO_BOOLEAN.title = "To Boolean";
      n_TO_BOOLEAN.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['to-boolean', "+A+"]" );
      }

      n_TO_STRING.title = "To String";
      n_TO_STRING.prototype.onExecute = function()
      {
        var A = this.getInputData(0);
        this.setOutputData( 0, "['to-string', "+A+"]" );
      }

      LiteGraph.registerNodeType("Conversions/To Number", n_TO_NUMBER );
      LiteGraph.registerNodeType("Conversions/To Boolean", n_TO_BOOLEAN );
      LiteGraph.registerNodeType("Conversions/To String", n_TO_STRING );
    },
/*
register_constant(){
      n_CONSTANT.title = "CONSTANT";
      n_CONSTANT.desc = "Constant value";
      n_CONSTANT.prototype.onExecute = function()
      {
        //var value = this.inputNumber.value;
        //this.setOutputData( 0, value );
        this.setOutputData(0, parseFloat( this.properties["value"] ) );
      }

      n_CONSTANT.prototype.setValue = function(v)
      {
        if( typeof(v) == "string") v = parseFloat(v);
        this.properties["value"] = v;
        this.setDirtyCanvas(true);
      };

      n_CONSTANT.prototype.onDrawBackground = function(ctx)
      {
        //show the current value
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
      }
      n_CONSTANT.prototype.onPropertyChanged = function(ctx)
      {
        //show the current value
        this.inputNumber.value = Number(this.properties["value"]).toFixed(3);
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
      }
      LiteGraph.registerNodeType("Data/CONSTANT", n_CONSTANT );

    },
*/
    register_color() {

      n_COLOR.title = "Color";
      n_COLOR.prototype.onExecute = function()
      {
        var r = this.colorPickerR.value;
        var g = this.colorPickerG.value;
        var b = this.colorPickerB.value;
        var a = this.colorPickerA.value;

        var alphaOutput = Math.round(a * 100) / 100
        this.setOutputData( 0, "'rgba("+Math.round(r)+","+Math.round(g)+","+Math.round(b)+"," +alphaOutput+" )'" );
      }

      n_COLOR.prototype.onPropertyChanged = function(ctx)
      {
        //show the current value
        this.colorPickerR.value = Math.round(Number(this.properties["red"]));
        this.colorPickerG.value = Math.round(Number(this.properties["green"]));
        this.colorPickerB.value = Math.round(Number(this.properties["blue"]));
        this.colorPickerA.value = Math.round(Number(this.properties["alpha"]) * 100) / 100;

        this.colorChosen = {
          r : this.colorPickerR.value,
          g: this.colorPickerG.value,
          b: this.colorPickerB.value,
          a: this.colorPickerA.value,
        }
        //this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
      }

      n_RGB.title = "RGB";
      n_RGB.prototype.onExecute = function()
      {
        var r = this.getInputData(0);
        var g = this.getInputData(1);
        var b = this.getInputData(2);
        this.setOutputData( 0, "['rgb', "+r+", "+g+", "+b+"]" );
      }

      n_RGBA.title = "RGBA";
      n_RGBA.prototype.onExecute = function()
      {
        var r = this.getInputData(0);
        var g = this.getInputData(1);
        var b = this.getInputData(2);
        var a = this.getInputData(3);
        this.setOutputData( 0, "['rgba', "+r+", "+g+", "+b+", "+a+"]" );
      }

      LiteGraph.registerNodeType("Color/Color", n_COLOR );
      LiteGraph.registerNodeType("Color/RGB", n_RGB );
      LiteGraph.registerNodeType("Color/RGBA", n_RGBA );
    },


    randomString(length, chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ') {
      var result = '';
      for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    }

  }
}



/* 🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯

                                            NODES DEFINITIONS

   🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯🔯*/


function n_FINALOUTPUT()
{
  //this.addOutput("value","string");
  //this.combo = this.addWidget("combo","Combo", all_fields[0], comboCallback, { values: all_fields} );
  //this.properties = { precision: 1 };
  this.addInput('',"string");
  this.size = [120,40];
}

function MyAddNode()
{
  this.addInput("A","number");
  this.addInput("B","number");
  this.addOutput("A+B","number");
  this.properties = { precision: 1 };
}

function comboCallback(e =null, v = null) {
  console.log(e);
  console.log(v);
}

function n_GET()
{
  this.addOutput("value","string");

  this.addProperty( "value", all_fields[0] );
  this.editable = { property:"value", type:"string" };
  
  this.combo = this.addWidget("combo","Combo", all_fields[0], (x,v) => {
    console.log(x);
    console.log(v);

    this.properties["value"] = x;
    //Number(x).toFixed(3)

    this.outputs[0].label = this.properties["value"];

  }, { values: all_fields} );
  //this.properties = { precision: 1 };
  this.size = [200,60];
}

function n_INTERPOLATE()
{

  

  this.addOutput("Result","string");

  this.height = 170;

  
  var input_name = 'input val';
  var output_name = 'output val';
  

  var comboxArray = all_fields;
  comboxArray.push("zoom");

  this.addInput("INPUT","string"); //0

  this.addInput("--------------------","separator"); //1

  this.addInput(input_name,"string"); //2
  this.addInput(output_name,"string"); //3

  this.addInput("--------------------","separator"); //4

  this.addInput(input_name,"string"); //5
  this.addInput(output_name,"string"); //6

  console.log('this', this)

  this.stepPairs = [
      [2,3],
      [5,6]
  ]
  this.addProperty( "steppairs", this.stepPairs );
  
  var currentIndexInput = 7;

  var working = false;
  var context = this;
  this.addPairButton = this.addWidget("button","Add step", null, function(v){

    if(!working) {
      working = true;
      context.addInput("--------------------","separator");
      context.addInput(input_name,"string");
      context.addInput(output_name,"string");

      context.stepPairs.push(
        [currentIndexInput+1, currentIndexInput+2]
      )

      context.properties['steppairs'] = context.stepPairs;
      
      context.height += 50;
      currentIndexInput += 3;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  //this.comboEasing = this.addWidget("combo","Easing", "linear", comboCallback, { values: ["linear", "step"] } );

  
  console.log(this.size);
  //this.properties = { precision: 1 };
  this.size = [200, this.height];
}

function n_ZOOM()
{
  this.addOutput("zoom","string");

  this.size = [200,40];
}


/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    CONSTANT
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

function n_CONSTANT()
{
  
  
  this.addOutput("value","string");

  //this.addProperty( "precision", 1.0 );
  this.addProperty( "value", 1.0 );
	this.editable = { property:"value", type:"number" };

  this.size = [200,80];

  this.inputNumber = this.addWidget("number","Value", 1, (x) => {
    this.properties["value"] = Number(x).toFixed(3);

    try {
      if(this.properties.value != undefined)
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
    }
    catch(e) {
      console.log(e)
    }

  }, null );
  //this.properties = { precision: 1 };
}

/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    MATH
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

function n_SUM()
{
  this.addInput("A","string"); 
  this.addOutput("output","string");
}

function n_ADD()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("output","string");
  this.properties = { precision: 1 };

}

function n_SUB()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("output","string");
  this.properties = { precision: 1 };

}

function n_DIV()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("output","string");
  this.properties = { precision: 1 };

}

function n_MULT()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("output","string");
  this.properties = { precision: 1 };

}

function n_POW()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("output","string");
  this.properties = { precision: 1 };
}

function n_CEIL()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_ROUND()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_FLOOR()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_ABS()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_MOD()
{
  this.addInput("A","string"); 
  this.addInput("B","string"); 
  this.addOutput("Result","string");
  this.properties = { precision: 1 };
}

function n_COS()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_SIN()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_TAN()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_ACOS()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_ASIN()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_ATAN()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_LN()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_LOG10()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_LOG2()
{
  this.addInput("","string"); 
  this.addOutput("o","string");
  this.properties = { precision: 1 };
}

function n_MIN()
{
  this.addInput("","string"); 
  this.addInput("","string"); 
  this.addOutput("Min","string");
  this.height = 60;
  this.size = [200, this.height];

  var currentIndexInput = 2;
  this.inputsIndexes = [0]

  var working = false;
  var context = this;
  this.addInputButton = this.addWidget("button","Add input", null, function(v){
    if(!working) {
      working = true;
      context.addInput("","string"); //
    
      context.inputsIndexes.push(currentIndexInput)
      context.height += 20;
      currentIndexInput += 1;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  this.properties = { precision: 1 };
}

function n_MAX()
{
  this.addInput("","string"); 
  this.addInput("","string"); 
  this.addOutput("Max","string");
  this.height = 60;
  this.size = [200, this.height];

  var currentIndexInput = 2;
  this.inputsIndexes = [0]

  var working = false;
  var context = this;
  this.addInputButton = this.addWidget("button","Add input", null, function(v){
    if(!working) {
      working = true;
      context.addInput("","string"); //
    
      context.inputsIndexes.push(currentIndexInput)
      context.height += 20;
      currentIndexInput += 1;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  this.properties = { precision: 1 };
}

function n_PI() {
  this.addOutput("PI","string");
  this.properties = { precision: 1 };
  this.size[0] = 80;
}

function n_E() {
  this.addOutput("output","string");
  this.properties = { precision: 1 };
  this.size[0] = 80;
}

function n_LN2() {
  this.addOutput("output","string");
  this.properties = { precision: 1 };
  this.size[0] = 80;
}

/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                  HEATMAP
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

function n_HEATMAPDENSITY() {
  this.addOutput("Heatmap density","string");
  this.properties = { precision: 1 };
  //this.size[0] = 80;
}

function n_POINTCOUNT() {
  this.addOutput("Point count","string");
  this.properties = { precision: 1 };
}

/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                  CONDITIONAL
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

function n_INF() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_SUP() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_INFequal() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_SUPequal() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_EQUAL() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_NOTEQUAL() {
  this.addInput("A","string"); 
  this.addInput("B","string"); 

  this.addOutput("bool","string");
  this.properties = { precision: 1 };
  this.size[0] = 100;
}

function n_NOT() {
  this.addInput("","string"); 

  this.addOutput("!","string");
  this.properties = { precision: 1 };
  this.size[0] = 80;
}

function n_ALL()
{
  this.addInput("","string"); 
  this.addInput("","string"); 
  this.addOutput("Min","string");
  this.height = 60;
  this.size = [200, this.height];

  var currentIndexInput = 2;
  this.inputsIndexes = [0]

  var working = false;
  var context = this;
  this.addInputButton = this.addWidget("button","Add condition", null, function(v){
    if(!working) {
      working = true;
      context.addInput("","string"); //
    
      context.inputsIndexes.push(currentIndexInput)
      context.height += 20;
      currentIndexInput += 1;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  this.properties = { precision: 1 };
}

function n_ANY()
{
  this.addInput("","string"); 
  this.addInput("","string"); 
  this.addOutput("Min","string");
  this.height = 60;
  this.size = [200, this.height];

  var currentIndexInput = 2;
  this.inputsIndexes = [0]

  var working = false;
  var context = this;
  this.addInputButton = this.addWidget("button","Add condition", null, function(v){
    if(!working) {
      working = true;
      context.addInput("","string"); //
    
      context.inputsIndexes.push(currentIndexInput)
      context.height += 20;
      currentIndexInput += 1;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  this.properties = { precision: 1 };
}

function n_NONE()
{
  this.addInput("","string"); 
  this.addInput("","string"); 
  this.addOutput("Min","string");
  this.height = 60;
  this.size = [200, this.height];

  var currentIndexInput = 2;
  this.inputsIndexes = [0]

  var working = false;
  var context = this;
  this.addInputButton = this.addWidget("button","Add condition", null, function(v){
    if(!working) {
      working = true;
      context.addInput("","string"); //
    
      context.inputsIndexes.push(currentIndexInput)
      context.height += 20;
      currentIndexInput += 1;
      context.size = [200, context.height];

      setTimeout(function(){ 
        working = false
      }, 800);
    }
    

  }, {} );

  this.properties = { precision: 1 };
}

function n_CASE() {
  this.addInput("Condition","string"); 
  
  this.addInput("","separator"); 
  this.addInput("true","string"); 
  this.addInput("false","string"); 
  this.addOutput("","string");

  //this.size = [200, 150];
}

/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                  CONVERSIONS
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

function n_TO_NUMBER() {
  this.addInput("value","string"); 
  this.addInput("fallback","string"); 

  this.addOutput("","string");
  this.properties = { precision: 1 };
}

function n_TO_BOOLEAN() {
  this.addInput("value","string"); 

  this.addOutput("","string");
  this.properties = { precision: 1 };
}

function n_TO_STRING() {
  this.addInput("value","string"); 

  this.addOutput("","string");
  this.properties = { precision: 1 };
}


/* %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                  COLOR
%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% */

/*
function n_CONSTANT()
{
  
  
  this.addOutput("value","string");

  //this.addProperty( "precision", 1.0 );
  this.addProperty( "value", 1.0 );
	this.editable = { property:"value", type:"number" };

  this.size = [200,80];

  this.inputNumber = this.addWidget("number","Value", 1, (x) => {
    this.properties["value"] = Number(x).toFixed(3);

    try {
      if(this.properties.value != undefined)
        this.outputs[0].label = Number(this.properties["value"]).toFixed(3);
    }
    catch(e) {
      console.log(e)
    }

  }, null );
  //this.properties = { precision: 1 };
}
*/

function n_COLOR() {
  this.size = [110,100]

  //this.bgImage = false;
  //this.bgImageUrl = 'https://i.stack.imgur.com/vPnRU.jpg'

  //this.bgImageUrl = 'http://www.jungle-parc.fr/fichier/bg-bois-cartoon.jpg'

  this.bgImageBack = true;
  this.bgImageBackUrl = 'img/alphanode.png'

  this.colorChosen = {
    r : 0,
    g: 0,
    b: 0,
    a: 1
  }

  this.addProperty( "red", 0.0 );
  this.addProperty( "green", 0.0 );
  this.addProperty( "blue", 0.0 );
  this.addProperty( "alpha", 0.0 );

  this.colorPickerR = this.addWidget("number","red", this.colorChosen.r, (x) => {
    //console.log('r', x);
    if (!isNaN(x)) {
      this.properties["red"] = Math.round(Number(x));
      this.colorChosen.r = x;
    }
  }, { min: 0, max: 255} );

  this.colorPickerG = this.addWidget("number","green", this.colorChosen.g, (x) => {
    //console.log('g', x);
    if (!isNaN(x)) {
      this.properties["green"] = Math.round(Number(x));
      this.colorChosen.g = x;
    }
  }, { min: 0, max: 255} );

  this.colorPickerB = this.addWidget("number","blue", this.colorChosen.b, (x) => {
    //console.log('b', x);
    if (!isNaN(x)) {
      this.properties["blue"] = Math.round(Number(x));
      this.colorChosen.b = x;
    }
  }, { min: 0, max: 255} );

  this.colorPickerA = this.addWidget("number","alpha", this.colorChosen.a, (x) => {
    //console.log('b', x);
    if (!isNaN(x)) {
      this.properties["alpha"] = Math.round(Number(x) * 100) / 100;
      this.colorChosen.a = x;
    }
  }, { min: 0, max: 1} );

  this.addInputButton = this.addWidget("button","Open color manager", null, (v) => {
    
    okanMap.currentColor = {
      r: this.colorChosen.r,
      g: this.colorChosen.g,
      b: this.colorChosen.b,
      a: this.colorChosen.a
    };
    okanMap.colorNodeId = this.id;
    okanMap.colorBlueprintMode = true;
    okanMap.colorPicker.open()
    okanMap.showColorPicker = true;
    

  }, {} );

  this.addOutput("color","string");


}

function n_RGB() {
  this.addInput("red","string"); 
  this.addInput("green","string"); 
  this.addInput("blue","string"); 

  this.addOutput("color","string");
  this.properties = { precision: 1 };
}

function n_RGBA() {
  this.addInput("red","string"); 
  this.addInput("green","string"); 
  this.addInput("blue","string"); 
  this.addInput("alpha","string"); 

  this.addOutput("color","string");
  this.properties = { precision: 1 };
}


</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../../assets/css/litegraph.css';
</style>
